/* ==========================================================================
   GIORGIA P BEAUTY LAB — JavaScript del tema
   Degani Agenzia Digitale
   --------------------------------------------------------------------------
   Vanilla JS puro. Niente jQuery, niente librerie, niente framework.
   Motivo: ogni KB di JavaScript che il browser deve scaricare, interpretare
   ed eseguire prima di mostrare la pagina abbassa il punteggio PageSpeed.
   Questo file, minificato, sta sotto i 6 KB.
   Caricato con `defer`: non blocca mai il rendering.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- 1. Header
     Ombra sotto l'header quando si scrolla. Usiamo IntersectionObserver
     invece dell'evento scroll: non gira a ogni pixel, quindi non causa jank. */
  function initHeader() {
    var header = document.querySelector('.header');
    if (!header) return;

    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none';
    document.body.prepend(sentinel);

    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ------------------------------------------------------------ 2. Menu mobile
     Con gestione corretta del focus: obbligo di accessibilità.
     A menu aperto il Tab non deve poter uscire dal pannello. */
  function initMobileNav() {
    var nav = document.getElementById('MobileNav');
    var openBtns = document.querySelectorAll('[data-nav-open]');
    var closeBtns = document.querySelectorAll('[data-nav-close]');
    if (!nav || !openBtns.length) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      var first = nav.querySelector('button, a');
      if (first) first.focus();
    }

    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      if (lastFocused) lastFocused.focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (!nav.classList.contains('is-open')) return;

      if (e.key === 'Escape') { close(); return; }

      if (e.key === 'Tab') {
        var f = nav.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Chiudendo il menu passando a desktop evitiamo stati incoerenti
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
      if (e.matches && nav.classList.contains('is-open')) close();
    });
  }

  /* -------------------------------------------------------------- 3. Accordion
     Animazione dell'altezza senza librerie, con aria-expanded corretto. */
  function initAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));

        if (reduceMotion) {
          panel.style.height = isOpen ? '0px' : 'auto';
          return;
        }

        if (isOpen) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function once() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', once);
          });
        }
      });
    });
  }

  /* ---------------------------------------------------------------- 4. Reveal
     Comparsa degli elementi allo scorrimento.

     Un solo IntersectionObserver per tutta la pagina, non uno per elemento:
     l'osservatore lavora fuori dal thread principale, quindi anche con
     duecento elementi osservati il costo resta trascurabile. Ogni elemento
     viene smesso di osservare appena è comparso — l'animazione va una volta
     sola, non a ogni passaggio.

     Il margine negativo in basso fa partire l'animazione quando l'elemento
     è entrato per un'ottava parte: se parte al primo pixel, chi scorre
     veloce vede solo la fine del movimento e sembra uno scatto. */
  var TIPI_REVEAL = '.reveal, .reveal-up, .reveal-left, .reveal-right, .reveal-zoom, .reveal-wipe';

  function initReveal() {
    var items = document.querySelectorAll(TIPI_REVEAL);
    if (!items.length) return;

    /* ── LA COMPARSA ALLO SCORRIMENTO E' STATA TOLTA ──────────────────
       Su una pagina lunga i blocchi che entrano in dissolvenza vogliono
       dire che qualcosa si muove quasi sempre mentre si scorre, e chi
       scorre veloce non vede l'effetto: vede uno scatto. La cliente lo ha
       segnalato come «leggeri bug quando scorro», ed erano l'effetto.
       Tutto e' visibile da subito. Restano le classi nel markup — servono
       al foglio di stile e non costa niente lasciarle — ma qui non si arma
       piu' niente e nessun osservatore lavora durante lo scorrimento.
       (Il resto della funzione e' rimasto sotto, non raggiungibile, per
       poterla riaccendere togliendo queste tre righe.) */
    items.forEach(function (el) { el.classList.add('is-visible'); });
    return;

    /* eslint-disable no-unreachable */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    /* NIENTE NASCE NASCOSTO — L'ANIMAZIONE SI ARMA, NON SI DISARMA.
       Prima il CSS nascondeva tutti i reveal e questo script li accendeva:
       ma il primo disegno puo' avvenire PRIMA che uno script `defer` giri, e
       in quella finestra la pagina mostrava i fondi senza il testo — la
       sfumatura rosa e poi le parole. Qualunque rincorsa (marcare il primo
       schermo, accorciare i ritardi) stringe la finestra ma non la chiude.
       Adesso il verso e' rovesciato: il CSS non nasconde NIENTE di suo.
       E' questo script che arma l'animazione (`is-armed`) — e la arma solo
       sotto la piega, dove l'elemento entrera' scorrendo. La corsa fra primo
       disegno e script ora puo' solo finire bene: se lo script arriva tardi,
       la pagina e' semplicemente tutta visibile da subito, senza effetto.
       UN MECCANISMO D'ENTRATA DEVE FALLIRE VERSO IL VISIBILE. */
    var soglia = (window.innerHeight || 800) * 1.15;
    var armati = [];
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top >= soglia) {
        el.classList.add('is-armed');
        armati.push(el);
      }
    });
    items = armati;
    if (!items.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------- 5. Navigazione categorie
     Nella pagina trattamenti evidenzia la categoria che stai guardando. */
  function initCategoryNav() {
    var nav = document.querySelector('.cat-nav');
    if (!nav) return;

    var links = nav.querySelectorAll('.cat-nav__link');
    var groups = [].slice.call(document.querySelectorAll('.treatment-group[id]'));
    if (!groups.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, { rootMargin: '-25% 0px -65% 0px' });

    groups.forEach(function (g) { io.observe(g); });
  }

  /* ------------------------------------------------------- 6. Galleria prodotto */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!full) return;
        main.src = full;
        main.srcset = '';
        main.alt = alt;
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');
      });
    });
  }

  /* ----------------------------------------------- 7. Selettore varianti corso
     Online / In presenza: cambia prezzo, disponibilità e variant id
     senza ricaricare la pagina. */
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;

      var idInput = form.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var submitBtns = form.querySelectorAll('button[type="submit"]');

      picker.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;

        if (idInput) idInput.value = input.value;

        // il riepilogo sopra il pulsante: dice a parole cosa si sta comprando,
        // così la scelta si legge anche senza guardare quale riquadro è acceso
        var scelta = document.querySelector('[data-variant-scelta-testo]');
        if (scelta) {
          var t = input.dataset.titolo || '';
          scelta.textContent = t.toLowerCase().indexOf('nline') >= 0 ? 'Corso online' : 'Corso in presenza';
        }
        if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;

        if (compareEl) {
          if (input.dataset.compare && input.dataset.compare !== '') {
            compareEl.textContent = input.dataset.compare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (submitBtns.length) {
          var available = input.dataset.available === 'true';
          submitBtns.forEach(function (submitBtn) {
            submitBtn.disabled = !available;
            submitBtn.textContent = available
              ? (submitBtn.dataset.textAvailable || 'Acquista ora')
              : 'Non disponibile';
          });
        }
      });
    });
  }

  /* --------------------------------------------- Pulsante acquisto sticky corso */
  function initCourseStickyAddToCart() {
    document.querySelectorAll('[data-course-sticky-bar]').forEach(function (bar) {
      var form = bar.closest('form');
      if (!form) return;

      var mainButton = form.querySelector('button[name="add"]:not([data-course-sticky-button])');
      var stickyButton = bar.querySelector('[data-course-sticky-button]');
      if (!mainButton || !stickyButton) return;

      function setVisible(visible) {
        bar.hidden = !visible;
        document.body.classList.toggle('has-course-sticky-atc', visible);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          setVisible(!entries[0].isIntersecting);
        }, { threshold: 0 });
        observer.observe(mainButton);
      } else {
        var update = function () {
          var rect = mainButton.getBoundingClientRect();
          setVisible(rect.bottom <= 0 || rect.top >= window.innerHeight);
        };
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  /* -------------------------------------------------------- 8. Contatore carrello */
  function initCartCount() {
    document.addEventListener('gp:cart-updated', function () {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            var cambiato = el.textContent !== String(cart.item_count);
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
            // Piccolo scatto quando il numero cambia davvero: conferma
            // all'occhio che il prodotto è entrato nel carrello, senza
            // bisogno di un avviso che copre la pagina.
            if (cambiato && !el.hidden) {
              el.classList.remove('is-bump');
              void el.offsetWidth;            // forza il riavvio dell'animazione
              el.classList.add('is-bump');
            }
          });
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------- Avvio */
  function init() {
    initHeader();
    initMobileNav();
    initAccordions();
    initReveal();
    initCategoryNav();
    initGallery();
    initVariantPicker();
    initCourseStickyAddToCart();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ─────────────────────────────────────────────────────────────────────────
   LA BARRA SCOMPARE SCENDENDO E TORNA SALENDO
   -------------------------------------------------------------------------
   Su una pagina lunga — quaranta schede di trattamenti — una barra sempre
   fissa si mangia ottanta pixel di schermo per tutta la lettura. Ma toglierla
   del tutto vuol dire costringere a risalire in cima per cambiare pagina.

   Il compromesso che funziona: scende con te mentre leggi, torna appena fai
   il gesto di risalire. È il gesto stesso a dire «sto cercando qualcosa».

   Due accortezze che sembrano dettagli:
   · si aggancia a `requestAnimationFrame`, non all'evento scroll grezzo:
     lo scroll parte anche cento volte al secondo, il fotogramma sessanta.
   · sotto i 140 pixel dall'alto la barra resta sempre visibile, o alla
     prima riga di scorrimento sparirebbe e sembrerebbe un difetto.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  /* SI AGISCE SUL CONTENITORE, NON SULLA BARRA.

     Shopify avvolge la sezione in <div id="shopify-section-header">, ed è
     QUELLO l'elemento che sta appiccicato in cima (vedi capitolo 38 del
     foglio di stile: dentro un contenitore alto quanto sé stessa, la barra
     non aveva un millimetro in cui muoversi e scorreva via come tutto il
     resto). Se la classe la mettessimo ancora sulla barra, la barra
     scivolerebbe fuori dal contenitore lasciando in cima una striscia vuota
     che intercetta i tocchi.

     Il ripiego su `.header` serve all'anteprima dell'editor e a qualunque
     contesto in cui il contenitore non ci sia. */
  var barraInterna = document.querySelector('.header');
  if (!barraInterna) return;
  var barra = barraInterna.closest('.shopify-section') || barraInterna;
  var ultimo = window.pageYOffset, atteso = false;

  function valuta() {
    var y = Math.max(0, window.pageYOffset);
    var giu = y > ultimo;
    // Il pannello del menu aperto blocca tutto: se la barra sparisse
    // mentre il pannello è aperto, il bottone di chiusura se ne andrebbe
    // con lei.
    var aperto = document.body.classList.contains('is-locked');
    if (!aperto && y > 140 && giu && (y - ultimo) > 4) {
      barra.classList.add('is-hidden');
    } else if (!giu && (ultimo - y) > 4) {
      barra.classList.remove('is-hidden');
    }
    if (y <= 140) barra.classList.remove('is-hidden');
    ultimo = y;
    atteso = false;
  }

  window.addEventListener('scroll', function () {
    if (!atteso) { atteso = true; window.requestAnimationFrame(valuta); }
  }, { passive: true });
})();
